export default class {

    /*@ngInject*/
    constructor($http, ORDENES_URL){
        Object.assign(this, {$http, ORDENES_URL});
    }

    getHistorial(limit){
        return this.$http.get(this.ORDENES_URL + '/historial/me?limit=' + limit);
    }

    getHistorialDetail(id){
        console.log('id', id);
        return this.$http.get(this.ORDENES_URL + '/historial/me/' + id);
    }
}



// WEBPACK FOOTER //
// ./client/app/historial-route/historial.service.js